var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMeeshaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0AC380;}\n\t.st1{fill:#FFD206;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.42,0.44L19.42,0.44c-0.82,0-1.48,0.66-1.48,1.48v1.61c0,0.82,0.66,1.48,1.48,1.48h0 c0.82,0,1.48-0.66,1.48-1.48V1.92C20.9,1.11,20.23,0.44,19.42,0.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.42,5.76c-0.29,0-0.58,0.09-0.82,0.25c-0.24,0.16-0.43,0.38-0.54,0.65c-0.08,0.18-0.1,0.37-0.14,0.55 c-0.03,0.18-0.07,0.36-0.11,0.53c-0.09,0.35-0.21,0.69-0.36,1.02C17.3,9.08,17.13,9.4,16.93,9.7c-0.09,0.13-0.18,0.25-0.27,0.37 c-0.86,1.08-2.06,1.84-3.38,2.13c-0.73,0.16-1.2,0.88-1.04,1.61c0.14,0.63,0.7,1.07,1.32,1.07c0.09,0,0.19-0.01,0.29-0.03 c1.53-0.33,2.94-1.09,4.09-2.17v9.4c0,0.82,0.66,1.48,1.48,1.48c0.82,0,1.48-0.66,1.48-1.48V7.24 C20.9,6.42,20.23,5.76,19.42,5.76z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.58,0.44L4.58,0.44c0.82,0,1.48,0.66,1.48,1.48v1.61c0,0.82-0.66,1.48-1.48,1.48h0 c-0.82,0-1.48-0.66-1.48-1.48V1.92C3.1,1.11,3.77,0.44,4.58,0.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.58,5.76c0.29,0,0.58,0.09,0.82,0.25c0.24,0.16,0.43,0.38,0.54,0.65c0.08,0.18,0.1,0.37,0.14,0.55 c0.03,0.18,0.07,0.36,0.11,0.53C6.28,8.09,6.4,8.43,6.55,8.76C6.7,9.08,6.87,9.4,7.07,9.7c0.09,0.13,0.18,0.25,0.27,0.37 c0.86,1.08,2.06,1.84,3.38,2.13c0.73,0.16,1.2,0.88,1.04,1.61c-0.14,0.63-0.7,1.07-1.32,1.07c-0.09,0-0.19-0.01-0.29-0.03 c-1.53-0.33-2.94-1.09-4.09-2.17v9.4c0,0.82-0.66,1.48-1.48,1.48S3.1,22.89,3.1,22.08V7.24C3.1,6.42,3.77,5.76,4.58,5.76z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeshaIcon);
export default __webpack_public_path__ + "static/media/meesha_icon.ffa52bceaf999e5b072094a47b00e342.svg";
export { ForwardRef as ReactComponent };